import { render } from "./UpdateCenterPage.vue?vue&type=template&id=0203e18a&ts=true"
import script from "./UpdateCenterPage.vue?vue&type=script&lang=ts"
export * from "./UpdateCenterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Centers/UpdateCenterPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0203e18a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0203e18a', __exports__)) {
    api.reload('0203e18a', __exports__)
  }
  
  module.hot.accept("./UpdateCenterPage.vue?vue&type=template&id=0203e18a&ts=true", () => {
    api.rerender('0203e18a', render)
  })

}


export default __exports__